(() => {
  const form = document.querySelector('[data-gift-amount-form]');
  if (!form) return;
  const select = form.querySelector('[data-denominations]');
  const picker = form.querySelector('[data-amount-picker]');
  const custom = picker.querySelector('[value="custom"]');
  const input = picker.querySelector('[data-custom-value]');
  const field = picker.querySelector('[data-custom-field]');
  const status = form.querySelector('[data-actual-value]');
  const options = [...select.options].filter(o => !o.disabled);
  const usd = picker.dataset.currency === 'USD';
  const purpose = document.querySelector(`[data-gift-purpose="${new URLSearchParams(location.search).get('gift')?.replace(/[^a-z-]/g, '')}"]`);
  const property = form.querySelector('[data-purpose-property]');
  const estimate = document.querySelector('[data-gift-estimate]');

  const announce = () => {
    const option = select.selectedOptions[0];
    status.textContent = `Actual gift credit and price: ${option.textContent.trim()}.`;
    if (purpose) {
      purpose.hidden = select.value !== purpose.dataset.variantId;
      property.disabled = purpose.hidden;
      property.value = purpose.hidden ? '' : purpose.querySelector('h2').textContent;
      if (estimate) estimate.hidden = purpose.hidden;
    }
  };
  const applyCustom = (normalize) => {
    if (input.value.trim() === '' || !Number.isFinite(input.valueAsNumber) || input.valueAsNumber < 10 || input.valueAsNumber > 250) {
      input.setCustomValidity('Enter an amount from $10 to $250.');
      status.textContent = 'Enter an amount from $10 to $250; amounts round to the nearest $5.';
      return false;
    }
    const cents = Math.round(input.valueAsNumber / 5) * 500;
    const option = options.find(o => Number(o.dataset.cents) === cents);
    if (!option) {
      input.setCustomValidity('That denomination is unavailable. Choose a preset amount.');
      status.textContent = 'That denomination is unavailable. Choose a preset amount.';
      return false;
    }
    input.setCustomValidity('');
    select.value = option.value;
    if (normalize) input.value = String(cents / 100);
    announce();
    return true;
  };
  const showCustom = () => {
    field.hidden = !custom.checked;
    input.disabled = !custom.checked;
    input.required = custom.checked;
    if (!custom.checked) input.setCustomValidity('');
  };
  custom.disabled = !usd;
  for (const radio of picker.querySelectorAll('[name="gift-amount-choice"]')) {
    radio.addEventListener('change', () => {
      showCustom();
      if (custom.checked) {
        applyCustom(false);
        input.focus();
      } else {
        select.value = radio.value;
        announce();
      }
    });
  }
  input.addEventListener('input', () => applyCustom(false));
  input.addEventListener('change', () => applyCustom(true));
  form.addEventListener('submit', event => {
    if (custom.checked && !applyCustom(true)) {
      event.preventDefault();
      input.reportValidity();
    }
  });
  const preset = [...picker.querySelectorAll('[name="gift-amount-choice"]')].find(r => r.value === select.value);
  if (preset) preset.checked = true;
  else if (usd) {
    custom.checked = true;
    input.value = String(Number(select.selectedOptions[0].dataset.cents) / 100);
  } else return;
  showCustom();
  announce();
  select.previousElementSibling.hidden = true;
  select.hidden = true;
  picker.hidden = false;
})();
